import { Fragment } from 'react';

import { ExternalLinkIcon } from 'lucide-react';
import { Link } from 'react-router';

export interface ListTooltipItem {
  id: string;
  label: string;
  href?: string;
}

interface ListTooltipContentProps {
  title: string;
  items: ListTooltipItem[];
}

export const ListTooltipContent = ({ title, items }: ListTooltipContentProps) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="flex max-w-xs min-w-45 flex-col">
      {title && (
        <p className="flex flex-col items-start justify-center gap-1.5 self-stretch border-b-[0.5px] border-b-muted/40 px-3 py-2 text-xs leading-5">
          {title}
        </p>
      )}

      <ul className="flex max-h-49 flex-col items-start gap-1 self-stretch overflow-y-auto px-2.5 pt-2.5 pb-3">
        {items.map((item, index) => (
          <Fragment key={item.id}>
            <li className="flex items-center justify-between gap-2 self-stretch rounded px-1 py-0.5">
              <span className="min-w-0 text-sm leading-5 break-words">{item.label}</span>
              {item.href && (
                <Link
                  to={item.href}
                  aria-label={item.label}
                  target="_blank"
                  onClick={(e) => e.stopPropagation()}
                  className="shrink-0 opacity-70 transition-opacity hover:opacity-100"
                >
                  <ExternalLinkIcon className="h-4 w-4" />
                </Link>
              )}
            </li>
            {index < items.length - 1 && (
              <li
                aria-hidden
                className="w-full shrink-0 self-stretch border-t-[0.5px] border-t-muted/40"
              />
            )}
          </Fragment>
        ))}
      </ul>
    </div>
  );
};
